if($('header#header').length){
    $('header#header .navigation-buttons').prepend($('header#header .navigation-tools').clone())
}